<script setup>
import { CSAT_TYPES } from 'shared/constants/messages';
import CSATLinkResponseInput from './CSATLinkResponseInput.vue';
import CSATInboxResponseInput from './CSATInboxResponseInput.vue';

const props = defineProps({
  selectedType: {
    type: String,
    default: 'link_response',
  },
});
const emit = defineEmits(['update']);
</script>

<template>
  <div class="flex flex-wrap gap-6 mt-2">
    <CSATLinkResponseInput
      :selected="props.selectedType === CSAT_TYPES.LINK_RESPONSE"
      @update="emit('update', $event)"
    />
    <CSATInboxResponseInput
      :selected="props.selectedType === CSAT_TYPES.INBOX_RESPONSE"
      @update="emit('update', $event)"
    />
  </div>
</template>
